import { i as f } from "./index-DNpObjKg.js";
export {
  f as default
};
//# sourceMappingURL=index.es.js.map
